/**
 * @description 險種 ID (enum)
 */
export enum InsuranceIdEnum {
  /** 旅平險 */
  Travel = 'TRAVEL'
}
